import styled from 'styled-components';

export const Wrapper = styled.div<{
  $isScrolled?: boolean;
  $scrollProgress?: number;
}>`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 80px;
  background-color: ${({ $scrollProgress }) =>
    `rgba(255, 255, 255, ${$scrollProgress || 0})`};
  opacity: 1; // Always fully opaque
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 1.25rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  transition: background-color 0.1s ease;
`;

export const BurgerButton = styled.button<{
  $isOpen: boolean;
  $scrollProgress?: number;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
`;

export const FullScreenOverlay = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.color.white};
  z-index: 999;
  transform: ${({ $isOpen }) =>
    $isOpen ? 'translateY(0)' : 'translateY(-100%)'};
  transition: transform 0.3s ease-in-out;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-y: auto;
  padding-top: 80px; /* Account for the header height */
`;

export const MenuContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 3rem;
  min-height: calc(100vh - 80px); /* Full height minus header */
  padding-bottom: 5rem; /* Same as menu bar height (80px) */
`;

export const MobileMenuList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  width: 100%;
`;

export const MobileMenuItemGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0rem;
  width: 100%;
`;

export const MobileMenuItem = styled.div<{
  $themeColor?: string;
  $hasSubItems?: boolean;
}>`
  font-size: 2rem;
  font-weight: 600;
  color: ${({ theme }) => theme.color.grey2};
  cursor: pointer;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
  text-align: center;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  position: relative;

  &:hover {
    color: ${({ $themeColor }) => $themeColor || '#000'};
  }
`;

export const ExpandIcon = styled.span<{ $isExpanded: boolean }>`
  font-size: 1rem;
  transition: transform 0.3s ease;
  transform: ${({ $isExpanded }) =>
    $isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};
  color: ${({ theme }) => theme.color.grey2};
`;

export const SubMenuList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  overflow: hidden;
  animation: slideDown 0.3s ease-out;
  background-color: rgba(0, 0, 0, 0.05);
  padding: 0.5rem;
  padding-top: 2rem;
  padding-bottom: 2rem;
  border-radius: 0.5rem;

  @keyframes slideDown {
    from {
      opacity: 0;
      max-height: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      max-height: 500px;
      transform: translateY(0);
    }
  }
`;

export const SubMenuItem = styled.div<{ $themeColor?: string }>`
  font-size: 2rem;
  font-weight: 400;
  color: ${({ theme }) => theme.color.grey2};
  cursor: pointer;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
  text-align: center;

  &:hover {
    color: ${({ $themeColor }) => $themeColor || '#000'};
  }
`;

export const CoLocatedEventsItem = styled.div`
  font-size: 2rem;
  font-weight: 600;
  color: ${({ theme }) => theme.color.grey2};
  cursor: pointer;
  padding: 2rem 0.5rem;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.05);
  width: 100%;
`;

export const CoLocatedEventsList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 100%;
  overflow: hidden;
  animation: slideDown 0.3s ease-out;
  background-color: rgba(0, 0, 0, 0.05);
  padding: 2rem 0.5rem;
  border-radius: 0.5rem;

  @keyframes slideDown {
    from {
      opacity: 0;
      max-height: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      max-height: 1000px;
      transform: translateY(0);
    }
  }
`;

export const CoLocatedEventLogoWrapper = styled.div`
  cursor: pointer;
  padding: 1rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  &:hover {
    transform: scale(1.05);
  }
`;

export const CoLocatedEventLogo = styled.img`
  max-width: 200px;
  max-height: 80px;
  width: auto;
  height: auto;
  object-fit: contain;
`;

export const EventInfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

export const EventInfoItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
`;

export const EventInfoText = styled.div`
  font-size: 1.5rem;
  font-weight: 400;
  color: ${({ theme }) => theme.color.grey2};
  text-align: center;
`;
